// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchProductForm_input__RKGOx","search_price_bg":"SearchProductForm_search_price_bg__1vcud"};